/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Flex, Button } from "@chakra-ui/react";
import { CustomerDetails } from "../../../components/customers/customer-details";

export default function Summary({
  customer,
  onCreateCustomer,
  editing,
  onPrevStep,
}) {
  const [customerDetails, setCustomerDetails] = useState({});
  useEffect(() => {
    setCustomerDetails(createCustomer());
  }, []);
  const createCustomer = () => {
    const _customerPayload = {
      clientId: customer.clientId,
      name: customer.name,
      shortName: customer.shortName,
      customerType: customer.customerType.id,
      customerCode: customer.customerCode,
      status: customer.status.id,
      hasSeparateDispenseCount: customer.hasSeparateDispenseCount,
      requiresEVhr: customer.requiresEVhr,
      offeredServices: customer.offeredServices.map((service) => ({
        serviceName: service.serviceName.id,
        cassettes: service.cassettes.map((cassette) => ({
          description: cassette.description?.id || "",
          denomination: cassette.denomination,
          cassetteType: cassette.cassetteType.id,
          maker: cassette.maker,
          limit: cassette.limit,
          dualScanning: cassette.dualScanning,
        })),
        denominations: service.denominations.map((deno) => ({
          currency: deno.denominationCurrency?.shortName || "",
          multiple: deno.denominationMultiple?.id || "",
          shape: deno.shape?.id,
          version: deno.version,
        })),
      })),
      accounts: customer.accounts.map((acc) => ({
        title: acc.title,
        accountNo: acc.accountNo,
        branchCode: acc.branchCode,
      })),
      contactPersons: customer.contactPersons.map((person) => ({
        firstName: person.firstName,
        lastName: person.lastName,
        mobileNo: person.mobileNo,
        email: person.email,
        personalMobileNo: person.personalMobileNo,
        officeNo: person.officeNo,
        designation: person.designation,
      })),
      insuranceLimits: customer.insuranceLimits.map((limit) => ({
        type: limit.type.id,
        currency: limit.currency.shortName,
        pavement: limit.pavement,
        van: limit.van,
        bag: limit.bag,
      })),
      replenishmentModels: customer.replenishmentModels.map((model) => ({
        code: model.code,
        denominations: model.denominations.map((deno) => ({
          denomination: `${deno.currency?.shortName} ${deno.multiple.id}`,
          noOfCassettes: deno.noOfCassettes,
          noOfNotes: deno.noOfNotes,
        })),
      })),
      contracts: customer.contracts.map((contract) => ({
        contractCode: contract.contractCode,
        autoRenew: contract.autoRenew,
        autoRenewFor: contract.autoRenewFor,
        startDate: contract.startDate,
        endDate: contract.endDate,
        status: contract.status.id,
        contractSLAs: contract.contractSLAs.map((sla) => ({
          region: sla?.region.id || "",
          serviceType: sla?.serviceType.id || "",
          activityType: sla?.activityType.id || "",
          responseTime: sla.responseTime,
          attendedTime: sla.attendedTime,
          resolutionTime: sla.resolutionTime,
        })),
        invoicingCatalogs: contract.invoicingCatalogs.map((catalog) => ({
          invoicingCode: catalog.invoicingCode,
          currency: catalog.currency?.shortName || "",
          rate: catalog.rate,
          discount: catalog.discount,
        })),
      })),
      escalationGroups: customer.escalationGroups.map((group) => ({
        region: group.region?.id,
        routeNo: group.routeNo?.routeNo,
        escalationLevel: `${group.escalationLevel}`,
        inAppRecipients: group.inAppRecipients.map((rec) => rec.item),
        emailRecipients: group.emailRecipients.map((rec) => rec.item),
        callRecipients: group.callRecipients.map((rec) => rec.item),
      })),
    };
    return _customerPayload;
  };
  return (
    <>
      <CustomerDetails customer={customerDetails} />
      <Flex
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        <Button onClick={onPrevStep}>Back</Button>
        <Button
          onClick={() => {
            onCreateCustomer(customerDetails);
          }}
        >
          {editing ? "Update Customer" : "Create Customer"}
        </Button>
      </Flex>
    </>
  );
}
